module.exports = __webpack_public_path__ + "static/img/39.107.193.85.6ee3e2ef.png";